<template>
  <div class="select-class">
    <div class="table">
      <table>
        <tr>
          <th>点击选课</th>
          <th>新版课程</th>
          <th>讲师</th>
          <th>讲数</th>
          <th>价格</th>
          <!-- <th v-if="showTitle">活动价</th> -->
          <!-- <th>免费体验</th> -->
        </tr>
        <tr @click="check(item.MyClassId)" :class="checkList.indexOf(item.MyClassId) > -1 ? 'checked' : ''" v-for="(item, index) in curClassObj.BzContainMyClassList" :key="index">
          <td>
            <span class="gou"></span>
          </td>
          <td class="text-c">{{item.MyClassName.replace("取证","VIP").replace("取证VIP","VIP")}}</td>
          <td>{{item.Teacher | teacherFilter}}</td>
          <td>{{item.CourseNum}}讲</td>
          <!-- <td>¥{{item.GoodPrice}}</td> -->
          <td>¥{{item.SpecialPrice || item.ActivityPrice || item.GoodPrice}}</td>
          <!-- <td class="price" v-if="item.SpecialPrice>0">
            <font color="#e45433">{{item.SpecialPrice>0?"¥"+item.SpecialPrice:"暂无优惠"}}</font>
          </td> -->
          <!-- <td><a class="listen" target="_blank" :href="'/course/study/?mid='+item.MyClassId">免费试听</a></td> -->
        </tr>
      </table>
    </div>
    <div class="div" style="text-align: right;">
      <a target="_blank" :href="'/shopping/?myclassid=' + checkList" class="ico-sure" v-if="checkList.length > 0">立即报名</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectClass",
  data() {
    return {
      showTitle: false,
      checkList: []
    }
  },
  props: {
    curClassObj: {
      type: Object,
      default: () => {}
    }
  },
  filters: {
    teacherFilter: function(value) {
      return value?.replace('233','');
    }
  },
  mounted() {
    // this.showTitle = false;
    // this.curClassObj.BzContainMyClassList.forEach(item => {
    //   if(item.SpecialPrice > 0){
    //     this.showTitle = true;
    //   }
    // });
    this.check(this.curClassObj.BzContainMyClassList[0].MyClassId)
  },
  methods: {
    check(id) {
      if (this.checkList.indexOf(id) > -1) {
        this.checkList.splice(this.checkList.indexOf(id), 1)
      } else {
        this.checkList.push(id)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../assets/css/index.scss";
.select-class{
  // height: 440px;
  // overflow-y: auto;
}
.table{
  height: 420px;
  overflow-y: auto;
}
table{
  border-collapse: collapse;
  border-spacing: 0;
  text-align: center;
  color:rgb(51, 51, 51);
  font-size: 15px;
  width: 100%;
  tr{
    cursor: pointer;
  }
  td{
    padding: 10px;
    border-top: 1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
    &:nth-child(2) {
      width: 48%;
      text-align: left;
    }
  }
  th{
    line-height: 50px;
    text-align: center;
    color: #666;
    background: #f5f5f5;
  }
  .listen {
    display: inline-block;
    width: 68px;
    line-height: 30px;
    font-size: 12px;
    background-color: #fff;
    @include dialog_select_class_color();
    @include dialog_select_class_border();
    border-radius: 2px;
    text-align: center;
    text-decoration: none;
  }
}
.main .gou { display: inline-block; width: 16px; height: 16px; background: url(https://img.233.com/x/sea-modules/extend/wxpopup/4.0.0/css/check.png) no-repeat; }
.main .checked { background-color: #f5f5f5; }
.main .checked .gou { background: url(https://img.233.com/x/sea-modules/extend/wxpopup/4.0.0/css/checked.png); }
/*报名按钮*/
.main .ico-sure { text-decoration: none; width: 100px; height: 40px; line-height: 40px; display: inline-block; @include dialog_select_class_border(); border-radius: 3px; background: #e45433; color: #fff; vertical-align: middle; text-align: center; white-space: nowrap; font-weight: 400; font-size: 16px; cursor: pointer; margin-top: 16px; }
.main .ico-sure:hover { @include dialog_select_class_background(); }

.main .wx-popup-err{@include dialog_select_class_color();padding-right: 10px;}
</style>